import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from '../hooks/useInView';

export default function Projects() {
  const [ref, inView] = useInView();
  const { t } = useTranslation();
  const items = t('projects.items', { returnObjects: true });

  return (
    <section id="projects" className={`section projects${inView ? ' in-view' : ''}`} ref={ref}>
      <div className="section__container">
        <h2 className="section__title">{t('projects.title')}</h2>
        <div className="projects__grid">
          {items.map((project, i) => (
            <div key={i} className="project-card">
              <div className="project-card__header">
                <h3 className="project-card__title">{project.title}</h3>
                <span className="project-card__status">{project.status}</span>
              </div>
              <p className="project-card__desc">{project.description}</p>
              <div className="project-card__stack">
                {project.stack.map(tech => (
                  <span key={tech} className="tag tag--small">{tech}</span>
                ))}
              </div>
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="project-card__link"
              >
                {project.linkLabel || t('projects.viewLink')}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
